import React, { useEffect, useState } from 'react'
import { useAuth } from '../../../../context/AuthContext';
import { queries } from '@testing-library/react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../../../firebase';

const TotalBalance = ({ partyID }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [totalAmount, setTotalAmount] = useState(0);

  function getTransactions(partyID) {
    const q = query(collection(db, "Businesses", bid, "Ledger"));
    const subscribe = onSnapshot(q, (querySnapshot) => {
      var totalCredit = 0;
      var totalDebit = 0;
      querySnapshot.forEach((doc) => {
        if (doc.data().partyID === partyID) {
          if (doc.data().creditAmount) {
            totalCredit = parseFloat(totalCredit) + parseFloat(doc.data().creditAmount);
          }

          if (doc.data().debitAmount) {
            totalDebit = parseFloat(totalDebit) + parseFloat(doc.data().debitAmount);
          }
        }
      });

      setTotalAmount(parseFloat(totalCredit) - parseFloat(totalDebit));
    });

    return () => subscribe;
  }

  useEffect(() => {
    getTransactions(partyID);
  }, [])

  return `₹ ${parseFloat(totalAmount.toFixed(2))}`;
}

export default TotalBalance;
